import styled from "styled-components";
import LayoutModal from "../Layout/LayoutModal";
import "../Styles/component.css";
import "../Styles/fonts.css";
import "../Styles/global.css";

export const MemberAlarmBox = ({
  title,
  description,
  handleClickX,
  reloadOnConfirm = true,
}) => {
  return (
    <Box>
      <div className="hrz-wrapper center">
        <p className="bold-text" style={{ fontSize: "20px" }}>
          {title}
        </p>
      </div>
      <div className="hrz-wrapper center" style={{ marginTop: "10px" }}>
        <p style={{ color: "#222222" }}>{description}</p>
      </div>

      <div
        className="blueBtn-base center"
        style={{
          marginTop: "30px",
          width: "400px",
          height: "60px",
          borderRadius: "10px",
          fontFamily: "notoSans-medium",
        }}
        onClick={() => {
          handleClickX();
          if (reloadOnConfirm) {
            window.location.replace("member");
          }
        }}
      >
        확인
      </div>
    </Box>
  );
};

const MemberAlarm = ({
  title,
  description,
  handleClickX,
  reloadOnConfirm = true,
}) => {
  return (
    <LayoutModal
      Modal={
        <MemberAlarmBox
          title={title}
          description={description}
          handleClickX={handleClickX}
          reloadOnConfirm={reloadOnConfirm}
        />
      }
    />
  );
};

const Box = styled.div`
  padding: 30px;
  border-radius: 20px;
  background-color: #ffffff;
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.2);
`;

export default MemberAlarm;
